module.exports = __webpack_public_path__ + "static/media/boom-lift.9ad3ade4.svg";